import React from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DescriptionIcon from "@mui/icons-material/Description";
import { Routes, Route, Navigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader/PageHeader";
import { TemplatesTab } from "./Templates/TemplatesTab";
import { FlowsTab } from "./Flows/FlowsTab";
import { DashboardTab } from "./Dashboard/DashboardTab";
import { GeneratedDocumentsTab } from "./Templates/GeneratedDocumentsTab/GeneratedDocumentsTab";
import { useFlowsAutomationsPage } from "./useFlowsAutomationsPage";

export const FlowsAutomationsPage: React.FC = () => {
  const { activeTab, handleTabChange } = useFlowsAutomationsPage();

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <PageHeader
        title="Flows & Automations"
        subtitle="Automate workflows, generate documents, and manage process templates"
      />

      <Paper
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="flows and automations tabs"
          >
            <Tab
              icon={<DashboardIcon />}
              iconPosition="start"
              label="Dashboard"
              data-testid="tab-dashboard"
            />
            <Tab
              icon={<AccountTreeIcon />}
              iconPosition="start"
              label="Flows"
              data-testid="tab-flows"
            />
            <Tab
              icon={<NoteAddIcon />}
              iconPosition="start"
              label="Generate Documents"
              data-testid="tab-generate"
            />
            <Tab
              icon={<DescriptionIcon />}
              iconPosition="start"
              label="Templates"
              data-testid="tab-templates"
            />
          </Tabs>
        </Box>

        <Box sx={{ flex: 1, overflow: "auto" }}>
          <Routes>
            <Route path="dashboard" element={<DashboardTab />} />
            <Route path="flows" element={<FlowsTab />} />
            <Route path="generate" element={<GeneratedDocumentsTab />} />
            <Route path="templates" element={<TemplatesTab />} />
            <Route path="" element={<Navigate to="dashboard" replace />} />
            <Route path="*" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </Box>
      </Paper>
    </Box>
  );
};
